import React from "react";
import { compose, branch } from "recompose";
import EnhanceCurrencySelector from "./EnhanceCurrencySelector";
import CurrencySelectorQuery from "./CurrencySelectorQuery.gql";
import { formatCurrency } from "./formatCurrency";
import { defineMessages, useIntl } from "react-intl";
import Selector from "theme/components/molecules/Selector";

const messages = defineMessages({
  title: {
    id: "modules.User.CurrencySelector.title",
    defaultMessage: "Change currency",
  },
});

const CurrencySelector = (props) => {
  const intl = useIntl();
  return (
    <Selector
      title={intl.formatMessage(messages.title)}
      current={formatCurrency(props.currency)}
      value={props.currency}
      options={props.availableCurrencies.map((currency) => {
        return {
          value: currency,
          label: formatCurrency(currency),
        };
      })}
      onSelect={(currency) => props.selectCurrency({ currency })}
    />
  );
};

export default compose(
  EnhanceCurrencySelector({ CurrencySelectorQuery }),
  branch(
    (props) => props.loading || props.availableCurrencies.length < 2,
    () => () => null,
    (BaseComponent) => BaseComponent
  )
)(CurrencySelector);
